import Form from 'components/Form';
import { IFormValues } from 'routes/Main/type';

import RowContainer from '../components/RowContainer';
import RowContent from '../components/RowContent';
import SectionTitle from '../components/SectionTitle';

import SubMuiRadio from './MuiRadioGroupSub';

interface Props extends IFormValues {
  disabled?: boolean;
}

const FunctionalEvaluation = (props: Props) => {
  const { disabled, getValues, setValue } = props;

  return (
    <RowContainer>
      <SectionTitle title="ADL(Activities of daily Living)" mb={0} />

      <RowContainer ratio={12}>
        <RowContent title="Self Sitting" titleRatio={3.5} childrenRatio={8}>
          <SubMuiRadio
            i18nKey="HOSPITALIZATION.FUNCTIONAL.EVALUATION"
            values={[1, 2, 3]}
            disabled={disabled}
            defaultValue={getValues('functional_evaluation.sit')}
            onChange={v => setValue('functional_evaluation.sit', v)}
          />
        </RowContent>
        <RowContent
          title="Standing up alone from sitting"
          titleRatio={3.5}
          childrenRatio={8}
        >
          <SubMuiRadio
            i18nKey="HOSPITALIZATION.FUNCTIONAL.EVALUATION"
            values={[1, 2, 3]}
            disabled={disabled}
            defaultValue={getValues('functional_evaluation.stand_up')}
            onChange={v => setValue('functional_evaluation.stand_up', v)}
          />
        </RowContent>
        <RowContent
          title="Moving from bed to wheelchair"
          titleRatio={3.5}
          childrenRatio={8}
        >
          <SubMuiRadio
            i18nKey="HOSPITALIZATION.FUNCTIONAL.EVALUATION"
            values={[1, 2, 3]}
            disabled={disabled}
            defaultValue={getValues('functional_evaluation.wheel_chair')}
            onChange={v => setValue('functional_evaluation.wheel_chair', v)}
          />
        </RowContent>
        <RowContent
          title="Independent walking"
          titleRatio={3.5}
          childrenRatio={8}
        >
          <SubMuiRadio
            i18nKey="HOSPITALIZATION.FUNCTIONAL.EVALUATION"
            values={[1, 2, 3]}
            disabled={disabled}
            defaultValue={getValues('functional_evaluation.walk')}
            onChange={v => setValue('functional_evaluation.walk', v)}
          />
        </RowContent>
      </RowContainer>
    </RowContainer>
  );
};

export default FunctionalEvaluation;
